/** Tonal palette for approval-matrix / per-stage selects (light chip bg + saturated label). */
export type ReneoSelectChipTone = 'blue' | 'violet' | 'emerald' | 'amber';

const CHIP_TONE: Record<
    ReneoSelectChipTone,
    {
        chipBg: string;
        chipBorder: string;
        labelColor: string;
        removeColor: string;
        removeHoverBg: string;
        removeHoverColor: string;
        /** Tailwind background class for list bullets (same hue family as chips). */
        dotBgClass: string;
    }
> = {
    blue: {
        chipBg: '#dbeafe',
        chipBorder: '#93c5fd',
        labelColor: '#1d4ed8',
        removeColor: '#2563eb',
        removeHoverBg: '#bfdbfe',
        removeHoverColor: '#1e3a8a',
        dotBgClass: 'bg-blue-500',
    },
    violet: {
        chipBg: '#ede9fe',
        chipBorder: '#c4b5fd',
        labelColor: '#6d28d9',
        removeColor: '#7c3aed',
        removeHoverBg: '#ddd6fe',
        removeHoverColor: '#5b21b6',
        dotBgClass: 'bg-violet-500',
    },
    emerald: {
        chipBg: '#d1fae5',
        chipBorder: '#6ee7b7',
        labelColor: '#047857',
        removeColor: '#059669',
        removeHoverBg: '#a7f3d0',
        removeHoverColor: '#065f46',
        dotBgClass: 'bg-emerald-500',
    },
    amber: {
        chipBg: '#fef3c7',
        chipBorder: '#fcd34d',
        labelColor: '#b45309',
        removeColor: '#d97706',
        removeHoverBg: '#fde68a',
        removeHoverColor: '#92400e',
        dotBgClass: 'bg-amber-500',
    },
};

export function getReneoSelectChipToneDotClass(tone: ReneoSelectChipTone): string {
    return CHIP_TONE[tone].dotBgClass;
}

export function getReneoSelectChipTonePalette(tone: ReneoSelectChipTone) {
    return CHIP_TONE[tone];
}
